import { IAbUseExperiment } from '../../types/abUseExperiments';

export const isActiveExperiment = (experiments: IAbUseExperiment[], experimentName: string, activeGroup: string) => {
  const experiment = experiments.find(exp => exp.experimentName === experimentName);

  return Boolean(experiment && experiment.groupName === activeGroup);
};
